import {
  Box,
  Button,
  FormControlLabel,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSuperAdminSinglePlan } from "../../../context/SuperAdmin/SinglePlanContext";
import {
  Estado
} from "../../../interfaces/SuperAdmin/Others/iDataEstado";
import { PutSuscriptFields } from "../../../interfaces/SuperAdmin/Pages/iDataSuscripcion";

const EditSuscriptModal = () => {
  const {
    isEditModalOpen,
    isEditing,
    selectedSuscript,
    toggleEditModal,
    editSuscription,
  } = useSuperAdminSinglePlan();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm<PutSuscriptFields>();

  useEffect(() => {
    if (selectedSuscript) {
      const { estado, fecha_inicio } = selectedSuscript;
      reset({ estado, fecha_inicio });
    }
  }, [selectedSuscript]);

  const handleClose = () => {
    if (!isEditing) {
      reset();
      toggleEditModal(false);
    }
  };

  const fechaInicio = watch("fecha_inicio");
  const isToday = fechaInicio === new Date().toISOString().split("T")[0];

  const handleFechaChange = (newDate: string) => {
    setValue("fecha_inicio", newDate);
    if (!newDate || newDate !== new Date().toISOString().split("T")[0]) {
      setValue("estado", Estado.INACTIVO);
    }
  };

  const handleSubmitForm = (data: PutSuscriptFields) => {
    console.log(data);

    if (selectedSuscript) {
      console.log(data);
      editSuscription(selectedSuscript.id_suscripcion, data);
    }
  };

  return (
    <Modal
      open={isEditModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)",
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography variant="h6" component="h2">
          Editar suscripción
        </Typography>

        {/* Campo de fecha de inicio */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Fecha de inicio
          </Typography>
          <Controller
            name="fecha_inicio"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                type="date"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: new Date().toISOString().split("T")[0],
                }}
                sx={{ minWidth: "100%", mt: 1 }}
                onChange={(e) => handleFechaChange(e.target.value)}
              />
            )}
          />
        </Box>

        {/* Switch para id_estado */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Estado
          </Typography>
          <FormControlLabel
            control={
              <Controller
                name="estado"
                control={control}
                render={({ field }) => (
                  <Switch
                    {...field}
                    checked={field.value === Estado.ACTIVO}
                    onChange={(e) =>
                      setValue(
                        "estado",
                        e.target.checked ? Estado.ACTIVO : Estado.INACTIVO
                      )
                    }
                    disabled={!isToday}
                  />
                )}
              />
            }
            label=""
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isEditing}
            type="submit"
          >
            {isEditing ? "Guardando" : "Guardar"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditSuscriptModal;
